<script>
    import Carousel from "../components/Carousel.svelte";
    import { onMount } from 'svelte';
    import { navigate } from '../router.js';

    let items = [];
    let contentLoaded = false;

    onMount(async () => {
        try {
            const res = await fetch('portfolio/manifest.json');
            if (!res.ok) return;
            const manifest = await res.json();

            const featured = manifest.filter(function(e) { return e.featured; });

            const loaded = await Promise.all(featured.map(async function(entry) {
                const infoRes = await fetch(entry.info);
                if (!infoRes.ok) return null;
                const info = await infoRes.json();
                const dir = entry.info.split('/').slice(0, -1).join('/');
                const slug = dir.split('/').pop();
                const image = info.images && info.images[0] ? dir + '/' + info.images[0] : null;
                return image ? { title: info.title || '', image, slug } : null;
            }));

            items = loaded.filter(Boolean);
        } catch (e) {
            // fail silently — carousel simply won't render
        }
        contentLoaded = true;
    });
</script>

<div class="demo-container" class:loaded={contentLoaded}>
    {#if items.length > 0}
        <div class="carousel-demo">
            <Carousel {items} title="FEATURED" on:select={e => navigate(`/portfolio/${e.detail}`)} />
        </div>
    {/if}
</div>

<style>
    .demo-container {
        opacity: 0;
        transition: opacity 0.3s ease;
        min-height: 100vh;
    }

    @media (max-width: 768px) {
        .demo-container {
            min-height: unset;
        }
    }

    .loaded {
        opacity: 1;
    }

    .carousel-demo {
        width: 100%;
        background-color: transparent;
    }
</style>
